import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { "format-key": "0" }
const _hoisted_2 = { class: "_mt-0" }
const _hoisted_3 = { "format-key": "0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")
  const _component_base_button = _resolveComponent("base-button")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    title: _ctx.Resources.ProjectHome.AddToCartRestrictedModalTitle,
    "is-visible": true
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_base_button, {
        width: "wide",
        theme: "accent",
        onClick: _withModifiers($options.close, ["prevent"]),
        "data-qa": "modal-button:Confirm"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.Resources.Common.ModalConfirmButton), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_ctx.Resources.ProjectHome.AddToCartRestrictedModalFirstParagraph), 1 /* TEXT */),
      _createElementVNode("p", null, [
        _createVNode(_component_localize, {
          resource: _ctx.Resources.ProjectHome.AddToCartRestrictedModalSecondParagraph
        }, {
          default: _withCtx(() => [
            _createElementVNode("strong", _hoisted_1, _toDisplayString($props.shippingLocation), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["resource"])
      ]),
      _createElementVNode("p", _hoisted_2, [
        _createVNode(_component_localize, {
          resource: _ctx.Resources.ProjectHome.AddToCartRestrictedModalThridParagraph
        }, {
          default: _withCtx(() => [
            _createElementVNode("strong", _hoisted_3, _toDisplayString($props.currentLocation), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["resource"])
      ]),
      _createElementVNode("p", null, [
        _createVNode(_component_localize, {
          resource: _ctx.Resources.ProjectHome.AddToCartRestrictedModalFourthPagraph
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              "format-key": "0",
              class: "_tc--accent _pa-0",
              onClick: _cache[0] || (_cache[0] = (...args) => ($options.handleClick && $options.handleClick(...args)))
            }, _toDisplayString(_ctx.Resources.ProjectHome.AddToCartRestrictedModalParagraphAction), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["resource"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title"]))
}